/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./spinner.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./spinner.component";
var styles_SpinnerComponent = [i0.styles];
var RenderType_SpinnerComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_SpinnerComponent, data: {} });
export { RenderType_SpinnerComponent as RenderType_SpinnerComponent };
export function View_SpinnerComponent_0(_l) { return i1.ɵvid(2, [], null, null); }
export function View_SpinnerComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "lp2-spinner", [], null, null, null, View_SpinnerComponent_0, RenderType_SpinnerComponent)), i1.ɵdid(1, 49152, null, 0, i2.SpinnerComponent, [i1.ElementRef], null, null)], null, null); }
var SpinnerComponentNgFactory = i1.ɵccf("lp2-spinner", i2.SpinnerComponent, View_SpinnerComponent_Host_0, { size: "size", color: "color" }, {}, []);
export { SpinnerComponentNgFactory as SpinnerComponentNgFactory };
//# sourceMappingURL=spinner.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/spinner/spinner.component.ngfactory.js
// module id = 142
// module chunks = 27 28 29